import { languageMap } from ".."

languageMap.gherkin = {
	comments: {
		line: "#",
	},
}
